import moment, { Moment } from 'moment';

enum TaxDateRange {
  WHOLE,
  MONTH_ONE,
  MONTH_THREE,
  MONTH_LAST,
  CUSTOM,
}

export const allCases = [TaxDateRange.WHOLE, TaxDateRange.MONTH_LAST, TaxDateRange.MONTH_ONE, TaxDateRange.MONTH_THREE, TaxDateRange.CUSTOM];

export const messageOf = (filter: TaxDateRange) => {
  switch (filter) {
    case TaxDateRange.WHOLE:
      return '전체';
    case TaxDateRange.MONTH_LAST:
      return '지난 달';
    case TaxDateRange.MONTH_ONE:
      return '최근 1개월';
    case TaxDateRange.MONTH_THREE:
      return '최근 3개월';
    case TaxDateRange.CUSTOM:
      return '직접 입력';
    default:
      return undefined;
  }
};

export const filterFrom = (filter: TaxDateRange) => {
  switch (filter) {
    case TaxDateRange.WHOLE:
      return undefined;
    case TaxDateRange.MONTH_LAST:
      return moment().subtract(1, 'month').set('date', 1);
    case TaxDateRange.MONTH_ONE:
      return moment().subtract(1, 'month');
    case TaxDateRange.MONTH_THREE:
      return moment().subtract(3, 'month');
    case TaxDateRange.CUSTOM:
      return undefined;
    default:
      return undefined;
  }
};

export const filterTo = (filter: TaxDateRange, from?: Moment) => {
  const to = moment(from);
  const lastDate = from?.daysInMonth() ?? 31;
  switch (filter) {
    case TaxDateRange.WHOLE:
      return undefined;
    case TaxDateRange.MONTH_LAST:
      return to?.set('date', lastDate);
    case TaxDateRange.MONTH_ONE:
      return to?.add(1, 'month');
    case TaxDateRange.MONTH_THREE:
      return to?.add(3, 'month');
    case TaxDateRange.CUSTOM:
      return undefined;
    default:
      return undefined;
  }
};

export default TaxDateRange;
